<template>
    <Sheet>  <h2>{{routeTitle}}</h2>


             <el-form :model="model"
                      :rules="rules"
                      label-width="190px"
                      ref="form">
                 <el-form-item label="身份證字號"
                               prop="iDno">
                     <el-input placeholder="請輸入身份證字號"
                               v-model="model.iDno"></el-input>
                 </el-form-item>
                 <el-form-item label="姓名"
                               prop="name">
                     <el-input placeholder="請輸入姓名"
                               v-model="model.name"></el-input>
                 </el-form-item>
                 <el-form-item label="部別"
                               prop="divisName">
                     <el-input placeholder="請輸入部別"
                               v-model="model.divisName"></el-input>
                 </el-form-item>
                 <el-form-item label="學號"
                               prop="studentId">
                     <el-input placeholder="請輸入學號"
                               v-model="model.studentId"></el-input>
                 </el-form-item>
                 <el-form-item label="系所"
                               prop="departmentName">
                     <el-input placeholder="請輸入系所"
                               v-model="model.departmentName"></el-input>
                 </el-form-item>
                 <el-form-item label="班級"
                               prop="className">
                     <el-input placeholder="請輸入班級"
                               v-model="model.className"></el-input>
                 </el-form-item>
                 <el-form-item label="電子郵件"
                               prop="email">
                     <el-input placeholder="請輸入電子郵件"
                               v-model="model.email"></el-input>
                 </el-form-item>
                 <el-form-item label="行動電話"
                               prop="mobiphone">
                     <el-input placeholder="請輸入行動電話"
                               v-model="model.mobiphone"></el-input>
                 </el-form-item>
                 <el-form-item label="戶籍地址"
                               prop="domicile">
                     <el-input placeholder="請輸入戶籍地址"
                               v-model="model.domicile"></el-input>
                 </el-form-item>
                 <el-form-item label="測驗類別"
                               prop="category">
                     <el-select v-model="model.category" placeholder="請選擇" tabindex="2">
                         <el-option v-for="item in categoryitem"
                                    :key="'n'.concat(item.no)"
                                    :label="item.codeName"
                                    :value="item.codeName">
                         </el-option>
                         <el-option key="n00" label="無" :value="0" :disabled="true" />
                     </el-select>
                 </el-form-item>
                 <el-form-item :label="'聽力前測等級\nListening Pretest level'"
                               prop="lpre_test">
                               <el-input placeholder="請輸入聽力前測等級(Listening Pretest level)"
                               v-model="model.lpre_test"></el-input>
                 </el-form-item>
                  <el-form-item :label="'閱讀前測等級\nReading Pretest level'"
                               prop="rpre_test">
                               <el-input placeholder="請輸入閱讀前測等級(Reading Pretest level)"
                               v-model="model.rpre_test"></el-input>
                 </el-form-item>
                 <el-form-item :label="'前測日期\nPretest date'"
                               prop="pre_date">
                               <el-date-picker
                                placeholder="前測日期(Pretest date)"
                                type="date"
                                v-model="model.pre_date"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                 </el-form-item>

                 <el-form-item :label="'聽力後測成績\nListening Posttest level'"
                               prop="lpost_test">
                     <el-select v-model="model.lpost_test" placeholder="請選擇" tabindex="2">
                         <el-option v-for="item in pre_testitem"
                                    :key="'n'.concat(item.no)"
                                    :label="item.codeName"
                                    :value="item.codeName">
                         </el-option>
                         <el-option key="n00" label="無" :value="0" :disabled="true" />
                     </el-select>
                 </el-form-item>
                 <el-form-item :label="'閱讀後測成績\nReading Posttest level'"
                               prop="rpost_test">
                      <el-select v-model="model.rpost_test" placeholder="請選擇" tabindex="2">
                         <el-option v-for="item in pre_testitem"
                                    :key="'n'.concat(item.no)"
                                    :label="item.codeName"
                                    :value="item.codeName">
                         </el-option>
                         <el-option key="n00" label="無" :value="0" :disabled="true" />
                     </el-select>
                 </el-form-item>
                 <el-form-item :label="'後測日期\nPosttest date'"
                               prop="post_date">
                               <el-date-picker
                                placeholder="後測日期(Posttest date)"
                                type="date"
                                v-model="model.post_date"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                 </el-form-item>
                 <el-form-item :label="'銀行名稱/銀行分行\nBank Name/Branch Name'"
                               prop="bankname">
                     <el-input placeholder="請輸入銀行名稱/銀行分行(Bank Name/Branch Name)"
                               v-model="model.bankname"></el-input>
                 </el-form-item>
                 <el-form-item :label="'銀行帳號\nBank Account Number'"
                               prop="bankno">
                     <el-input placeholder="請輸入銀行帳號(Bank Account Number)"
                               v-model="model.bankno"></el-input>
                 </el-form-item>
                 <el-form-item :label="'曾修習本校華語課程\nHave you ever taken Mandarin courses at NCUT'"
                               prop="iS_studyChinese">
                     <el-radio-group v-model="model.iS_studyChinese">
                         <el-radio :label="e.value"
                                   v-for="e in yesnos">
                             {{e.label}}
                         </el-radio>
                     </el-radio-group>
                     <span style="color:red;">
                         注意：若選「否」則不能申請(If you select "No", you cannot apply it.)
                     </span>
                 </el-form-item>
                 <el-form-item :label="'課程名稱\nCourse Name'"
                               prop="course">
                     <el-input placeholder="請輸入課程名稱(Course Name)"
                               v-model="model.course"></el-input>
                 </el-form-item>
                 <el-form-item :label="'等級\nLevel'"
                               prop="grade">
                     <el-select v-model="model.grade" placeholder="請選擇" tabindex="2" @change="money()">
                         <el-option v-for="item in gradeitem"
                                    :key="'n'.concat(item.no)"
                                    :label="item.codeName"
                                    :value="item.codeName">
                         </el-option>
                         <el-option key="n00" label="無" :value="0" :disabled="true" />
                     </el-select>

                 </el-form-item>

                 <el-form-item :label="'申請金額\nMonetary Award'"
                               prop="application_money">
                     <el-input placeholder="申請金額(Monetary Award)"
                               v-model="model.application_money" :disabled="true"></el-input>
                 </el-form-item>

                 <el-form-item :label="'申請報名費\nApply for registration fee'"
                               prop="iS_app_reg_fee"
                               v-if="model.fee_flag">
                     <el-radio-group v-model="model.iS_app_reg_fee"
                                     v-if="model.fee_flag">
                         <el-radio :label="e.value"
                                   v-for="e in yesnos"
                                   v-if="model.fee_flag">
                             {{e.label}}
                         </el-radio>
                     </el-radio-group>
                     <span style="color:red;">
                        「每人限申請一次」(Once only for each student)
                     </span>
                 </el-form-item>
                 <el-form-item :label="'報名費金額\nRegistration fee'"
                               prop="registery_fee"
                               v-if="model.fee_flag">
                     <el-input placeholder="報名費金額(Registration fee)"
                               v-model="model.registery_fee"
                               v-if="model.fee_flag" :disabled="model.iS_app_reg_fee==='否'"></el-input>
                 </el-form-item>
                 <!--<el-form-item label="是否審核"
                  prop="isReview">
        <el-radio-group v-model="model.isReview">
            <el-radio :label="e.value"
                      v-for="e in yesnos">
                {{e.label}}
            </el-radio>
        </el-radio-group>
    </el-form-item>
    <el-form-item label="核定金額"
                  prop="approved_amount">
        <el-input placeholder="核定金額"
                  v-model="model.approved_amount"></el-input>
    </el-form-item>
    <el-form-item label="核定內容"
                  prop="review_content">
        <el-input placeholder="核定內容"
                  v-model="model.review_content"></el-input>
    </el-form-item>-->
                 <el-form-item :label="'檢附資料(檢附文件若不完備，將不予受理)\nRequired Documents(the application will only be accepted after all the required documents are submitted)'" v-if="fileLimit">

                     <el-upload :action="action"
                                :before-remove="handleBeforeRemove"
                                :before-upload="beforeUpload"
                                :data="dataOptions"
                                :headers="uploadHeaders"
                                :limit="4"
                                :on-error="onUploadError"
                                :on-exceed="onExceedLimit"
                                :on-success="onUploadSuccess"
                                ref="upload">
                         <el-button>選擇檔案</el-button>
                         <template #tip>
                             <div class="el-upload__tip" style="font-size:large; font-weight:bold;color:red;">
                                 檔案不超過5MB，限以jpg或pdf格式上傳。
                             </div>
                         </template>
                     </el-upload>
                     <span style="color:red;">
                         檢附資料(Required Documents)：<br />
                         1、 2次檢定考試成績單影本或檢定合格證書/等級證明 Photocopy of two exam transcripts of certificates <br />
                            (前測若為校內測驗，則無則檢附No need to of proof from the test if you take an on-campus test)<br />
                         2、若當次考試報名費為學校補助，則不可申請，若無學校補助請附上報名費繳費證明。<br />
                            If the registration fee for the exam is subsidized by the school, it cannot be applied for. If there is no school subsidy, <br />
                            please attach proof of payment for the registration fee.<br />
                         3、學生證正面影本 Photocopy of the front side of the student ID<br />
                         4、居留證正反面影本 Photocopy of the front and back side of the ARC<br />
                         5、申請人本人銀行/郵局存封面影本一張 Photocopy the applicant's bank/post office passbook cover<br />
                         (獎助補助款將由學校直接匯入申請人提供之銀行帳戶 The subsidy will be directly transferred to the bank account provided by the applicant.)
                     </span>
                 </el-form-item>
                 <el-button @click="submit"  :disabled="model.iS_studyChinese==='否'">
                     送件(Submit)
                 </el-button>
             </el-form>
    </Sheet>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import moment from 'moment';
    import routeTitleMixin from './routeTitleMixin';
    import UploadMixin from '../uploadMixin';

    const defaultModel = {
        idno:'',
        name: '',
        divisName:'',
        studentId:'',
        departmentName:'',
        className:'',
        email: '',
        mobile: '',
        domicile:'',
        category:'',
        lpre_test:'',
        rpre_test:'',
        lpost_test:'',
        rpost_test:'',
        bankname:'',
        bankno:'',
        iS_studyChinese:null,
        course:'',
        grade:'',
        application_money:'0',
        iS_app_reg_fee:null,
        registery_fee:'0',
        isReview:null,
        approved_amount:'0',
        review_content:'',
        uploads: [],
    };

    export default {
        name: 'Form',
        data: () => ({
           categoryitem:null,
           pre_testitem:null,
           gradeitem:null,
           model: {...defaultModel},

            rules: {
                name: [
                    {required: true, message: '請輸入姓名', trigger: 'blur'}
                ],
               category: [
                    {required: true, message: '請選擇測驗類別', trigger: 'blur'}
                ],
                 lpost_test: [
                    {required: true, message: '請選擇聽力後測等級(Listening Posttest Level)', trigger: 'blur'}
                ],
                 rpost_test: [
                    {required: true, message: '請選擇閱讀後測等級(Reading Posttest Level)', trigger: 'blur'}
                ],
                 post_date: [
                    {required: true, message: '請輸入後測日期(Posttest Date)', trigger: 'blur'}
                ],
                course: [
                    {required: true, message: '請輸入課程名稱(Course Name)', trigger: 'blur'}
                ],
                bankname: [
                    {required: true, message: '請輸入銀行名稱/銀行分行(Bank Name/Branch Name)', trigger: 'blur'}
                ],
               bankno: [
                    {required: true, message: '請輸入請輸入銀行帳號(Bank Account Number)', trigger: 'blur'}
                ],
              iS_studyChinese: [
                    {required: true, message: '請選擇是否曾修習本校華語課程(Have you ever taken Mandarin courses at NCUT)', trigger: 'blur'}
                ],
             grade: [
                    {required: true, message: '請選擇等級(Level)', trigger: 'blur'}
                ],
            application_money: [
                    {required: true, message: '請輸入請輸入申請金額(Monetary Award)', trigger: 'blur'}
                ],
            iS_app_reg_fee: [
                    {required: true, message: '請選擇是否申請報名費(Apply for registration fee)', trigger: 'blur'}
                ],
            },
            url: 'upload',
        }),

        computed: {
            ...mapState('chineseform', ['forms', 'selectedForm']),
            ...mapState('codeDt', ['codeList']),

             yesnos() {
                return [
                    {label: '是(yes)', value: '是'},
                    {label: '否(no)', value: '否'},
                ];
            },

        },

        mixins: [routeTitleMixin, UploadMixin],

        methods: {
            ...mapActions('chineseform', {
                insert: 'insertFormAction',
                get: 'getstudFormsAction'
            }),
            ...mapActions('codeDt', {
                getCode: 'getCodeNo',
            }),
            money: function() {

                          if (this.model.grade == "A1-NTD$1800"){
                                     this.model.application_money=1800;
                              }
                           else if (this.model.grade == "A2-NTD$2000")
                           {
                                  this.model.application_money=2000;
                           }
                          else if (this.model.grade == "B1-NTD$2300")
                          {
                                  this.model.application_money=2300;
                          }
                          else if (this.model.grade == "B2-NTD$2500")
                          {
                                 this.model.application_money=2500;
                          }
                          else if (this.model.grade == "C1-NTD$2700")
                          {
                                  this.model.application_money=2700;
                          }
                          else if (this.model.grade == "C2-NTD$3000")
                          {
                                  this.model.application_money=3000;
                          }
                          
                   },
            submit() {

                const current = this.$refs['form'];
                current.validate(async valid => {
                    if (valid) {

                        const {success} = await this.insert({
                            ...this.model
                        });
                        if (success) {
                            this.$message({
                                type: 'success',
                                message: '表單送出成功'
                            });
                            this.$router.push('/StuchineseTable')
                        } else {
                            this.$message({
                                type: 'danger',
                                message: '表單送出失敗，請重試一次'
                            });
                        }
                        this.reset();
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '驗證失敗，請檢查*欄位'
                        });
                    }
                })
            },

            reset() {
                const vm = this;
                this.$refs['form'].resetFields();
                this.$nextTick(() => vm.$refs['form'].clearValidate());
                this.model = {...defaultModel};
                this.$refs['upload'].clearFiles();
            },

            onUploadSuccess(res) {
                this.model.uploads.push(res);
            },

            async handleBeforeRemove(file) {
                await this.beforeRemove(file);
                this.model.uploads = this.model.uploads.filter(f => f.uid !== file.uid);
            }
        },

        watch: {

            selectedForm(current) {

                this.model = {...current};
           }
        },

        async created() {
           var success = await this.getCode(11);

            if (success) {
                         this.categoryitem=success;}
           var pre_testtemp = await this.getCode(12);
         if (pre_testtemp ) {
                         this.pre_testitem=pre_testtemp;}

         var  gradetemp = await this.getCode(13);
    if (gradetemp) {
                         this.gradeitem=gradetemp;}

            this.get();
        }

    }</script>

<style scoped>
.el-form>>>.el-form-item .el-form-item__label {
   white-space: pre-line;
   height: 55px;
   line-height: 20px;
}
</style>